<template>
  <!-- 帳票出力画面 -->
  <div id="PDashboardPatientManagementModal">
    <div class="modal-card" style="width: 620px;">
      <header class="modal-card-head">
        <p class="modal-card-title">充実管理体制・指導管理レポート出力</p>
      </header>      
      <div class="summary-period-row">
        <span style="width: 120px;">集計期間</span>
        <input
            type="month"
            :min="minMonth"
            :max="maxMonth"
            v-model="fromMonth"
            style="width: 200px; margin: 20px 0px; font-size: 30px"
        />
        <span class="range">
          （{{ dateRange ? dateRange.display : "未選択" }}）
        </span>
      </div>
      <!-- <section class="modal-card-body" style="height: 680px;">
        
        </div>
      </section> -->
      <footer class="modal-card-foot">
        <b-button :disabled="!fromMonth" class="is-primary" style="margin-left: auto;" @click="outputGuidanceManagementReport">作成</b-button>
        <b-button class="is-primary" @click="cancel()">キャンセル</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
const UNEXPECTED_ERROR = "予期しないエラーが発生しました。";

export default {
  name: "PDashboardPatientManagementModal",
  data() {
    return {
      currentDate: null,
      fromMonth: (() => {
        const now = new Date();
        now.setMonth(now.getMonth() - 1);
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, "0");
        return `${y}-${m}`;
      })()
    };
  },
  computed: {
    dateRange() {
      if (!this.fromMonth) return null;

      const [year, month] = this.fromMonth.split("-").map(Number);

      // 開始（月初）: 2ヶ月前の1日
      const start = new Date(year, month - 3, 1);

      // 終了（月末）：翌月0日 = 当月末
      const end = new Date(year, month, 0);

      const formatYmd = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
      };
      const formatDisplay = (date) => {
        const y = date.getFullYear();
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${y}年${m}月${d}日`;
      };
      return {
        termStart: formatYmd(start),
        termEnd: formatYmd(end),
        display: `${formatDisplay(start)}～${formatDisplay(end)}`
      };
    },
    maxMonth() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      return `${y}-${m}`;
    },
    minMonth() {
      const now = new Date();
      now.setMonth(now.getMonth() - 3);
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      return `${y}-${m}`;
    }
  },
  watch: {
    fromMonth(value) {
      if (!value) return;

      if (value < this.minMonth) {
        this.fromMonth = this.minMonth;
      } else if (value > this.maxMonth) {
        this.fromMonth = this.maxMonth;
      }
    }
  },
  methods: {
    outputGuidanceManagementReport: async function(){
      let _this = this;
      await this.apiCall(
        function(client) {
          console.log(client.apis.externalPDashboard.outputGuidanceManagementReportPOST.toString());
          return client.apis.externalPDashboard.outputGuidanceManagementReportPOST({
            body:{
              searchConditions: {  
                termStart: _this.dateRange.termStart,
                termEnd: _this.dateRange.termEnd
              }
            }
          });

        },
        function(result) {
          if (result && result.status == 200) {
            console.log(result.data instanceof ArrayBuffer);

            console.log(result);
            console.log(result.headers);
            console.log(result.obj);


            // ダウンロードするファイル情報を取得
            let fileInfo = result.headers["content-disposition"].split("=")[1];
            // ファイル情報からファイル名を取得
            let fileName = fileInfo.slice(fileInfo.lastIndexOf("\'") + 1);
            const blob = new Blob([result.data], {
              type: "application/vnd.ms-excel.sheet.macroEnabled.12"
            });

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(fileName);
            // メッセージを表示する前にダウンロードを開始
            link.click();
            _this.showMessage("ファイルの作成が完了しました。");
          } else {
            // エラーメッセージを表示
            _this.showErrorMessage(UNEXPECTED_ERROR);
          }
        },
        function(result){
          // エラーメッセージを表示
          _this.showErrorMessage(result);
        }
      );
    },
    cancel() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card-body {
	padding: 5px;
}
.top-text{
  display: flex;
  justify-content: space-between;
  margin-left: 15px;
  margin-right: 15px;
}
#pDashboardPatientManagementTable {
  position: relative;
}
#pDashboardPatientManagementTable::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: white;
}
.summary-period-row {
  display: flex;
  align-items: center;
  gap: 10px; // ← 要素同士の間隔
}
.range {
  width: 280px;              // ← 固定幅（必要に応じて調整）
  display: flex;
  justify-content: center;   // 横方向の中央寄せ
  align-items: center;       // 縦方向の中央寄せ
  white-space: nowrap;       // 折り返し防止
}
input[type="month"]::-webkit-clear-button {
    display: none;
}
</style>
<style lang="scss">
#pDashboardPatientManagementTable .table-wrapper thead tr:nth-child(1) th {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 1px;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/PDashboardExcelDownload.vue